import { Button } from 'antd';
import styled     from 'styled-components';
import { COLORS } from 'styles/colors';

const BlueButton = styled(Button)`
  border-color: ${COLORS.PRIMARY_BLUE};
  color: ${COLORS.PRIMARY_BLUE};

  &:hover {
    border-color: ${COLORS.PRIMARY_BLUE};
    color: ${COLORS.PRIMARY_BLUE};
  }
`;

export default BlueButton;